import React from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import SEO from "../components/site/SEO";

function resolveUrl(u) {
    if (!u) return null;
    if (u.startsWith("http")) return u;
    return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}

export default function Temoignages() {
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        api.get("/testimonials")
            .then((r) => setItems(r.data))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="page-temoignages" className="pt-32 pb-24 px-6 md:px-12 lg:px-24">
            <SEO
                title="Témoignages clients"
                description="Ce que disent les couples, familles et passionnés d'automobile qui m'ont fait confiance. Retours authentiques sur mes prestations photo."
            />

            <div className="mb-20 max-w-3xl">
                <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">— Avis clients</p>
                <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95]">
                    Ce qu'ils en<br /><em className="italic text-[#c5a059]">disent.</em>
                </h1>
                <p className="text-zinc-400 mt-6 leading-relaxed">
                    Des couples, des familles, des passionnés. Voici leurs mots, sans filtre.
                </p>
            </div>

            {loading ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="h-56 bg-zinc-900 animate-pulse border border-white/5" />
                    ))}
                </div>
            ) : items.length === 0 ? (
                <p className="text-zinc-500 text-center py-20">Aucun témoignage pour l'instant.</p>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {items.map((t, i) => (
                        <article
                            key={t.id}
                            data-testid={`temoignage-${i}`}
                            className="relative bg-[#0f0f0f] border border-white/10 p-8 md:p-10 hover:border-[#c5a059]/40 transition-colors"
                        >
                            <span className="absolute top-4 right-6 font-serif-display text-7xl text-[#c5a059]/15 leading-none">"</span>
                            <div className="flex gap-1 mb-4">
                                {Array.from({ length: t.rating || 5 }).map((_, idx) => (
                                    <Star key={idx} size={14} strokeWidth={1.5} className="fill-[#c5a059] text-[#c5a059]" />
                                ))}
                            </div>
                            <p className="text-zinc-200 leading-relaxed font-serif-display text-xl italic">
                                {t.content}
                            </p>
                            <div className="flex items-center gap-4 mt-8 pt-6 border-t border-white/10">
                                {t.photo_url && (
                                    <img
                                        src={resolveUrl(t.photo_url)}
                                        alt={t.name}
                                        className="w-12 h-12 object-cover rounded-full border border-white/10"
                                    />
                                )}
                                <div>
                                    <p className="text-white">{t.name}</p>
                                    {t.role && (
                                        <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">{t.role}</p>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </div>
    );
}
